// ============================================================================
// SORTABLE HEADER COMPONENT
// ============================================================================

export default function SortableHeader({ field, label, sortField, sortDirection, onSort }) {
  const isActive = sortField === field;
  return (
    <span 
      style={{ 
        cursor: "pointer", 
        display: "flex", 
        alignItems: "center", 
        gap: 4,
        userSelect: "none",
      }}
      onClick={() => onSort(field)}
      title={`Sort by ${label}`}
    >
      {label}
      {isActive && (
        <span style={{ fontSize: 10, opacity: 0.7 }}>
          {sortDirection === 'asc' ? '▲' : '▼'}
        </span>
      )}
    </span>
  );
}
